import useSWR from 'swr';
import { fetcher } from '@/shared/api/fetcher';

const useCounters = () => {
  const { data, error, isLoading } = useSWR('/settings/counters', fetcher);

  return {
    counters: data,
    isLoadingCounters: isLoading,
    countersError: error,
  };
};

export { useCounters };
